import { axiosAuthAPI, axiosAccountAPI, axiosAPI } from '@/axios';

function login(account) {
  return axiosAuthAPI.post('/login', account);
}

function logout() {
  // axiosAuthAPI.defaults.withCredentials = true;
  return axiosAuthAPI.post('/logout', {});
}

function loadCurrentUser() {
  return axiosAccountAPI.get('/context');
}

function getChatUser(user) {
  const userData = {
    id: user.id,
    displayName: user.name,
    roleId: user.roleId,
  };
  return axiosAPI.post('/chat-token', userData);
}

function validateAuthTokenPermission(payload) {
  const { teamName, authToken } = payload;
  return axiosAuthAPI.post('/authorize', {}, {
    headers: {
      Authorization: `${teamName} ${authToken}`,
    },
  });
}

export {
  login,
  loadCurrentUser,
  logout,
  validateAuthTokenPermission,
  getChatUser,
};
